import { render, staticRenderFns } from "./Other.vue?vue&type=template&id=033890cb&scoped=true&"
import script from "./Other.vue?vue&type=script&lang=js&"
export * from "./Other.vue?vue&type=script&lang=js&"
import style0 from "../index.scss?vue&type=style&index=0&id=033890cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033890cb",
  null
  
)

export default component.exports